import { render } from "./OfficesOverview.vue?vue&type=template&id=6bd674ff&scoped=true&ts=true"
import script from "./OfficesOverview.vue?vue&type=script&lang=ts"
export * from "./OfficesOverview.vue?vue&type=script&lang=ts"

import "./OfficesOverview.vue?vue&type=style&index=0&id=6bd674ff&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bd674ff"]])

export default __exports__